import React from 'react';

const SiteRules = () => {
  return (
    <div className="proskins-content" style={{ padding: 'var(--spacing-lg)', margin: '0px auto' }}>
      <div className="proskins-card" style={{ marginBottom: 'var(--spacing-2xl)', display: 'flex' }}>
        <div className='about-content-container' style={{ marginBottom: 'var(--spacing-sm)', justifyContent: 'space-between' }}>
          
          <h1 className="proskins-section-title">Pro$kins Rules</h1>

          <h2>Game</h2>
          <p>
            Each Game is defined as a grouping of Participants who have selected Players in a tournament field 
            during the Player Selection Period for any week. There can be an infinite number of Games being played 
            during any week that cover the same tournament. New Games are started once a pre-determined number of 
            Players have been selected by the Participants. Regardless of whether the Player has been chosen by a 
            Participant or by Pro$kins, all Player’s scores are active once that week’s tournament begins.
          </p>

          <h2>Player Selection Period</h2>
          <p>
            The Player Selection Period refers to the time when Pro$kins has started to allow Participants to select 
            and pay for Players competing in that week’s tournament. All selections must be done on the Pro$kins 
            website or mobile app. A typical tournament concludes Sunday, with Player Selection beginning Monday at 
            9am EST and closing six hours before the first tee time.
          </p>
          
          <img 
            src="/golf-rule.png" 
            alt="Siterules" 
            className="proskins-right-image"
          />

          <h2>Participant</h2>
          <p>
            A Participant is someone over 21 years old who has created an account, completed KYC verification, 
            logged in, paid for and confirmed Player selections for a tournament week.
          </p>

          <h2>Player</h2>
          <p>
            A Player is any golfer, amateur or professional, in a given tournament monitored by Pro$kins. Players do 
            not receive winnings—only Participants are paid out.
          </p>

          <h2>Pool</h2>
          <p>
            The Pool is the total dollar amount available for payouts during any Game, reflecting how many Players 
            were selected by Participants. It is the net amount after Pro$kins fees and administration costs.
          </p>

          <h2>Daily Pot</h2>
          <p>
            The Daily Pot is the payout pool for any given round, typically 25% of the Pool (for 4-round tournaments). 
            Multi-course tournaments adjust this percentage based on the number of rounds.
          </p>

          <h2>Skin</h2>
          <p>
            A Skin is the lowest score on a hole by a Player in the field during a round. Only one Skin per hole per 
            round is possible. The payout depends on the Daily Pot, number of Skins, and Saw-offs.
          </p>

          <h2>Saw-off</h2>
          <p>
            A Saw-off occurs when only two Players record the same lowest score on a hole. Payout is $100 per 
            Participant ($200 total), unless otherwise noted.
          </p>

          <h2>Carryover</h2>
          <p>
            If no Skins are made in a round, the remaining Daily Pot carries over to the next round. Only Skins winners 
            receive Carryover payouts.
          </p>

          <h2>Walkback</h2>
          <p>
            A Walkback occurs in the final round if no Skins are scored. The remaining Daily Pot is split among 
            previous Skins winners. Saw-off winners only share if no Skins were made the entire tournament.
          </p>

          <h2>Raincheck</h2>
          <p>
            If a tournament is shortened, unplayed round pots are distributed among Skin winners of completed rounds. 
            If canceled before play, Participants receive refunds (minus admin fees).
          </p>

          <h2>Withdraw (WD)</h2>
          <p>
            If a Player withdraws before a tournament, refunds are issued. Once play starts, no refunds are given, 
            though Skin/Saw-off payouts are honored if earned.
          </p>

          <h2>Disqualification (DQ)</h2>
          <p>
            A Player DQ follows the same rules as WD.
          </p>

          <h2>Cut</h2>
          <p>
            The Cut reduces the field after round 2 (sometimes round 3). Typically the top 75 scores and ties advance. 
            Skins/Saw-offs earned by Players missing later rounds are still honored.
          </p>

          <h2>Zero Skins</h2>
          <p>
            If no Skins or Saw-offs are made, all money (minus fees) is refunded. If no Skins but some Saw-offs occur, 
            the Pool is split among Saw-off Participants.
          </p>
        </div>
      </div>  
    </div>
  );
};

export default SiteRules;
